/**
 *   Generated file. Do not edit
 */

import { WifiMode } from './models';
import { WifiProtocol } from './models';
import { WifiSSIDVisibility } from './models';
import { WifiKeyVisibility } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';
import { TapRequestFrame } from '@iotize/tap/client/api';
import * as serviceConverters from './service-converters';
import { converters as commonConverters } from '@iotize/tap/service/core';

const allConverters = {
  ...commonConverters,
  ...serviceConverters,
};

export const SERVICE_CALLS = {
  getMode: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/wifi/mode',
    path: '/1024//15',
    responseBodyDecoder: allConverters.wifiMode,
  } as ServiceCallType<void, WifiMode>,

  putMode: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/wifi/mode',
    path: '/1024//15',
    bodyEncoder: allConverters.wifiMode,
  } as ServiceCallType<WifiMode, void>,

  getKey: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/wifi/key',
    path: '/1024//16',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putKey: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/wifi/key',
    path: '/1024//16',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getHostname: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/wifi/hostname',
    path: '/1024//35',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  getIp: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/wifi/ip',
    path: '/1024//30',
    responseBodyDecoder: allConverters.stringIpv4,
  } as ServiceCallType<void, string>,

  putIp: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/wifi/ip',
    path: '/1024//30',
    bodyEncoder: allConverters.stringIpv4,
  } as ServiceCallType<string, void>,

  getGatewayIp: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/wifi/gateway-ip',
    path: '/1024//31',
    responseBodyDecoder: allConverters.stringIpv4,
  } as ServiceCallType<void, string>,

  putGatewayIp: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/wifi/gateway-ip',
    path: '/1024//31',
    bodyEncoder: allConverters.stringIpv4,
  } as ServiceCallType<string, void>,

  getIpMask: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/wifi/ip-mask',
    path: '/1024//32',
    responseBodyDecoder: allConverters.stringIpv4mask,
  } as ServiceCallType<void, string>,

  putIpMask: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/wifi/ip-mask',
    path: '/1024//32',
    bodyEncoder: allConverters.stringIpv4mask,
  } as ServiceCallType<string, void>,

  getDnsIp: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/wifi/dns-ip',
    path: '/1024//124',
    responseBodyDecoder: allConverters.stringIpv4,
  } as ServiceCallType<void, string>,

  putDnsIp: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/wifi/dns-ip',
    path: '/1024//124',
    bodyEncoder: allConverters.stringIpv4,
  } as ServiceCallType<string, void>,

  getSSID: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/wifi/ssid',
    path: '/1024//25',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putSSID: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/wifi/ssid',
    path: '/1024//25',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getCountryCode: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/wifi/country-code',
    path: '/1024//95',
    responseBodyDecoder: allConverters.uint16,
  } as ServiceCallType<void, number>,

  putCountryCode: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/wifi/country-code',
    path: '/1024//95',
    bodyEncoder: allConverters.uint16,
  } as ServiceCallType<number, void>,

  getProtocol: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/wifi/protocol',
    path: '/1024//96',
    responseBodyDecoder: allConverters.wifiProtocol,
  } as ServiceCallType<void, WifiProtocol>,

  putProtocol: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/wifi/protocol',
    path: '/1024//96',
    bodyEncoder: allConverters.wifiProtocolArray,
  } as ServiceCallType<WifiProtocol[], void>,

  getTxPower: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/wifi/tx-power',
    path: '/1024//97',
    responseBodyDecoder: allConverters.int8,
  } as ServiceCallType<void, number>,

  putTxPower: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/wifi/tx-power',
    path: '/1024//97',
    bodyEncoder: allConverters.int8,
  } as ServiceCallType<number, void>,

  getSSIDVisibility: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/wifi/ssid-visibility',
    path: '/1024//98',
    responseBodyDecoder: allConverters.wifiSSIDVisibility,
  } as ServiceCallType<void, WifiSSIDVisibility>,

  putSSIDVisibility: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/wifi/ssid-visibility',
    path: '/1024//98',
    bodyEncoder: allConverters.wifiSSIDVisibility,
  } as ServiceCallType<WifiSSIDVisibility, void>,

  getKeyVisibility: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/wifi/key-visibility',
    path: '/1024//99',
    responseBodyDecoder: allConverters.wifiKeyVisibility,
  } as ServiceCallType<void, WifiKeyVisibility>,

  putKeyVisibility: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/wifi/key-visibility',
    path: '/1024//99',
    bodyEncoder: allConverters.wifiKeyVisibility,
  } as ServiceCallType<WifiKeyVisibility, void>,

  getNetworkMode: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/wifi/network-mode',
    path: '/1024//128',
    responseBodyDecoder: allConverters.wifiMode,
  } as ServiceCallType<void, WifiMode>,

  putNetworkMode: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/wifi/network-mode',
    path: '/1024//128',
    bodyEncoder: allConverters.wifiMode,
  } as ServiceCallType<WifiMode, void>,

  getDisabled: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/wifi/disabled',
    path: '/1024//129',
    responseBodyDecoder: allConverters.boolean,
  } as ServiceCallType<void, boolean>,

  putDisabled: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/wifi/disabled',
    path: '/1024//129',
    bodyEncoder: allConverters.boolean,
  } as ServiceCallType<boolean, void>,
};
